/**
 * Minimum points required to apply a burn to a purchase.
 * Users below this threshold will not see the burn toggle/slider.
 *
 * TODO: this should be driven by the program config endpoint rather than hardcoded here.
 */
export const MINIMUM_POINTS_TO_APPLY = 1000
